import { render, staticRenderFns } from "./tmOverlayResize.vue?vue&type=template&id=035b02e5&"
import script from "./tmOverlayResize.vue?vue&type=script&lang=js&"
export * from "./tmOverlayResize.vue?vue&type=script&lang=js&"
import style0 from "./tmOverlayResize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports